import script from "./CartItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartItem.vue?vue&type=script&setup=true&lang=ts"

import "./CartItem.vue?vue&type=style&index=0&id=58d7b137&lang=scss"

const __exports__ = script;

export default __exports__